import { NgModule } from '@angular/core';

import { Section01Component } from './section01.component';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    Section01Component
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule
  ],
  exports: [
    Section01Component
  ]
})

export class Section01Module { }
